var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.articles),function(article,index){return _c('BlogArticle',{key:index,attrs:{"article":article}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }